// Copyright (c) 2023 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import BigLogo from '@modules/Public/assets/logo_big.png';

export interface BigLogoPngProps {
  className?: string;
}

const BigLogoPng: React.FC<BigLogoPngProps> = (props) => {
  const classes = withStyles.getClasses(props);
  return (
    <img 
      className={classes.root}
      src={BigLogo}
      alt='VI Logo'
    />
  );
};

const BigLogoPngStyled = withStyles(
  BigLogoPng, 
  (theme, props) => ({
    "root": {
      position: 'absolute',
      top: 20,
      left: 20,
      width: 128,
      height: 'auto',
    }
  })
);

export default BigLogoPngStyled;